import { TableCell, TableRow, cn } from '@shigo-ui/ui';
import type { DashboardDataTableColumn } from './DashboardDataTable.types';
import {
  dashboardDataTableStickyCellClassName,
  dashboardDataTableStickyCellStyle,
  isDashboardDataTableSelectionColumn,
} from './DashboardDataTableSticky';

type LoadingColumn = Pick<
  DashboardDataTableColumn<unknown>,
  'id' | 'className' | 'sticky' | 'stickyOffset'
>;

export function DashboardDataTableLoading({ columns }: { columns: readonly LoadingColumn[] }) {
  return Array.from({ length: 6 }, (_, rowIndex) => (
    <TableRow
      key={rowIndex}
      aria-hidden="true"
      className="border-border/40 h-[38px] hover:bg-transparent"
    >
      {columns.map((column, columnIndex) => (
        <TableCell
          key={column.id}
          data-selection-column={isDashboardDataTableSelectionColumn(column.id) || undefined}
          className={cn(
            'px-2 py-2.5 first:pl-4 last:pr-4',
            column.className,
            dashboardDataTableStickyCellClassName(column),
          )}
          style={dashboardDataTableStickyCellStyle(column)}
        >
          <div
            data-slot="dashboard-table-skeleton"
            style={{
              width: isDashboardDataTableSelectionColumn(column.id)
                ? undefined
                : `${String([72, 54, 84, 62, 76, 58][(rowIndex + columnIndex) % 6] ?? 72)}%`,
            }}
            className={cn(
              'h-2 max-w-full rounded-full',
              isDashboardDataTableSelectionColumn(column.id)
                ? 'border-border/40 mx-auto h-4 w-4 rounded-sm border bg-transparent'
                : 'skeleton min-w-4',
              column.className?.includes('text-right') && 'ml-auto',
            )}
          />
        </TableCell>
      ))}
    </TableRow>
  ));
}
